export const syncStates = {
  NOT_SAVED: 'NOT_SAVED',
  SAVING: 'SAVING',
  SAVED: 'SAVED'
}
